module.exports = __webpack_public_path__ + "img/IEC13746.d0b65de4.png";